module.exports = __webpack_public_path__ + "img/DIY, Tools & Lighting.b9dde716.png";